import { Component, OnInit, Input } from "@angular/core";
import { Router } from "@angular/router";

import {
  TicketCutoffDefaultType,
  TicketCutoffResume,
  TicketCutoffOperationType,
} from "./ticket-cutoff-type.model";
import { AuthService } from "../../services/auth.service";
import { Roles } from "../auth/auth.role";
import { CutoffService } from "../../services/cutoff.service";
import { DialogService } from "../../services/dialog.service";
import {
  faEye,
  faListAlt,
  faInfoCircle,
} from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: "app-cutoff",
  templateUrl: "./cutoff.component.html",
  styleUrls: ["./cutoff.component.scss"],
})
export class CutoffComponent implements OnInit {
  @Input() isIndex = false;

  faEye = faEye;
  faListAlt = faListAlt;
  faInfoCircle = faInfoCircle;

  model: Array<TicketCutoffResume> = null;
  displayedColumns = [
    "actions",
    "name",
    "defaultLimitTime",
    "currentLimitTime",
  ];
  cutoffOperationTypeEnum = TicketCutoffOperationType;

  constructor(
    private authService: AuthService,
    private router: Router,
    private cutoffService: CutoffService,
    private dialog: DialogService
  ) {}

  ngOnInit() {
    if (this.canChangeLimitTime && !this.isIndex) {
      this.getAdminLimitHours();
      this.displayedColumns.push("request");
    } else {
      this.getHomeLimitHours();
    }
  }

  getAdminLimitHours() {
    this.cutoffService
      .listResume()
      .subscribe((data: Array<TicketCutoffResume>) => {
        this.model = data;
      });
  }

  getHomeLimitHours() {
    this.cutoffService
      .listResumeIndex()
      .subscribe((data: Array<TicketCutoffResume>) => {
        this.model = data;
      });
  }

  openTimeUpdate(id: number = null) {
    if (id === null) {
      this.router.navigate(["/cutoff/cutoff-default-update"]);
    } else {
      this.router.navigate(["/cutoff/cutoff-default-update", id]);
    }
  }

  openExceptionHistory() {
    this.router.navigate(["/cutoff/history"]);
  }

  openAccountManagerFundDefault(cutoffTypeId: number, cutoffName: string) {
    setTimeout(() =>
      this.dialog.cutoffAccountManagerFundDefault(
        cutoffTypeId,
        cutoffName,
        this.isIndex
      )
    );
  }

  openRequest(
    cutoffTypeId: number = null,
    accountManagerId: number = null,
    fundId: number = null
  ) {
    const params: any = {};

    if (cutoffTypeId) {
      params.cutoffTypeId = cutoffTypeId;
    }
    if (accountManagerId) {
      params.accountManagerId = accountManagerId;
    }
    if (fundId) {
      params.fundId = fundId;
    }

    if (params === null) {
      this.router.navigate(["/cutoff/time-limit-request"]);
    } else {
      this.router.navigate(["/cutoff/time-limit-request/", params]);
    }
  }

  openCreateCutoff(
    cutoffOperationType: number = null,
    cutoffTypeId: number = null,
    accountManagerId: number = null,
    fundId: number = null
  ) {
    const params: any = {};

    if (cutoffOperationType) {
      params.cutoffOperationType = cutoffOperationType;
    }
    if (cutoffTypeId) {
      params.cutoffTypeId = cutoffTypeId;
    }
    if (accountManagerId) {
      params.accountManagerId = accountManagerId;
    }
    if (fundId) {
      params.fundId = fundId;
    }

    this.router.navigate(["/cutoff/cutoff-create/", params]);
  }

  canChangeCutoffDefault(): boolean {
    return this.authService.hasRole(Roles.ChangeDefaultLimitTime);
  }

  get canChangeLimitTime(): boolean {
    return this.authService.hasRole(Roles.ChangeLimitTime);
  }
}
